export function nthFilter() {
	return function(number: number): string {
		if (number > 3 && number < 21) return `${number}th`; // thanks kennebec
		switch (number % 10) {
		case 1:
			return `${number}st`;
		case 2:
			return `${number}nd`;
		case 3:
			return `${number}rd`;
		default:
			return `${number}th`;
		}
	};
}